import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Thank you people of the internet",
  "description": "",
  "published": "2014-11-27T00:00:00.000Z",
  "redirect_from": ["/blog/thank-you-people-of-the-internet/swizec/6621"],
  "categories": "Travel + Events",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Two days ago somebody stole the most popular article I've ever written - `}<a parentName="p" {...{
        "href": "http://swizec.com/blog/why-programmers-work-at-night/swizec/3198"
      }}>{`Why Programmers Work At Night`}</a>{`. The single most shared and reposted and stolen thing I've ever made.`}</p>
    <p>{`It's not the best thing I've ever written. God no. When I look at it now I think it flows poorly, uses strange wording, sounds weak and is just a mess. My writing has improved in three years.`}</p>
    <p>{`Wow, three years.`}</p>
    <p>{`But I remember when I first posted it. I just wanted to fill my post-every-day quota, my then girlfriend giving me the death stare because I kept writing well into our date because I had slept in that morning.`}</p>
    <p>{`She helped me pick the pictures. I hit publish and started apologizing for being so rude.`}</p>
    <p>{`Then everything went insane with the shares and the upvotes and the comments and the retweets. 200,000 uniques in two days.`}</p>
    <p>{`Some websites steal the article. Some ask for permission to repost. I've seen translations into various languages, some I couldn't even read the letters of.`}</p>
    <p>{`It's weird. But I don't mind. Spam websites gonna spam, right?`}</p>
    <p>{`But two days ago somebody stole it verbatim again. No attribution. Then they committed the greatest sin of the internets - posted their link to r/programming and to `}<a parentName="p" {...{
        "href": "http://news.ycombinator.com/",
        "title": "Hacker News"
      }}>{`Hacker News`}</a>{`.`}</p>
    <p>{`My fans ...fans is a strong word, I should say friends ... my friends got Hacker News to fix the submission link. A single comment was enough.`}</p>
    <p>{`On `}<a parentName="p" {...{
        "href": "http://reddit.com/",
        "title": "Reddit"
      }}>{`Reddit`}</a>{` there was no correction, but several comments mentioned that this was a spam submission and linked to the original article.`}</p>
    <p>{`I had no idea any of this was going on.`}</p>
    <p>{`But I woke up that morning to tweets from a few different people saying `}{`_`}{`"Hey dude, that guy stole your article and we are `}{`*`}{`_`}{`not`}{`*`}{`*`}{` okay with that!"`}{`*`}{`.`}</p>
    <p>{`Someone even let me know via Skype.`}</p>
    <p>{`But the best thing about this incident is that because I have amazing friends and good SEO, I sold 9 copies of the book that stemmed out of that article. It usually takes a month to sell that many. And 50 new mailing list subscribers to boot. Normally I get 5 a month.`}</p>
    <p>{`All that without attribution from the thieving website! Amazing.`}</p>
    <p>{`Thanks friends, fans, people of the internet, whatever I should call you. You're great. It warms my weasely black heart to see people care about my writing enough to make a fuss when it's misappropriated.`}</p>
    <p>{`I should probably finish that book huh ...`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      